/**
 * Constants and shared labels for the Job Listings feature.
 */

// Keka sends `jobType` as a numeric code. This is Keka's full list (mirrors the
// job-type list in Keka's own careers embed widget); any code not here falls
// back to DEFAULT_JOB_TYPE_LABEL rather than rendering a raw number.
export const JOB_TYPE_MAP = {
  1: "Part Time",
  2: "Full Time",
};

// Fallback shown when a job's `jobType` is empty or an unknown code.
export const DEFAULT_JOB_TYPE_LABEL = "Full Time";

// Location filter buckets that aren't a normal city. "Location Not Specified"
// groups jobs with no location (blank field, not an assertion of remote work);
// "Remote" groups jobs whose Keka location is named "Remote". Both are pinned to
// the top of the Location filter, but only shown when they actually have jobs.
export const NO_LOCATION_LABEL = "Location Not Specified";
export const REMOTE_LABEL = "Remote";

// Separator between multiple locations on a job card (PRD FR-4),
// e.g. "Kolkata, West Bengal · Pune, Maharashtra".
export const LOCATION_SEPARATOR = " · ";

// Sidebar filter group titles (as per the Figma design).
export const FILTER_TITLES = {
  location: "Location",
  department: "Department",
};

// Copy used in the header (matches the Figma design).
export const HEADER_SUBHEAD =
  "Browse open roles, filter by category, and apply to the ones that match your next step.";

// Search placeholder.
export const SEARCH_PLACEHOLDER = "Search roles...";

// Empty-state copy shown when jobs exist but the active filters/search hid them.
export const EMPTY_STATE_TITLE = "No roles match your search";
export const EMPTY_STATE_SUBTITLE =
  "Try adjusting your filters or clearing your search to see more openings.";

// Empty-state copy shown when there are genuinely no open roles (not a filter
// artefact) — distinct from EMPTY_STATE_* so we don't tell a visitor to "adjust
// filters" they never touched.
export const NO_OPENINGS_TITLE = "No open positions right now";
export const NO_OPENINGS_SUBTITLE =
  "We're not hiring for any roles at the moment. Please check back soon!";

// Copy shown while jobs are being fetched from the API.
export const LOADING_TITLE = "Loading open roles…";

// Copy shown when the jobs request fails.
export const ERROR_STATE_TITLE = "We couldn't load open roles";
export const ERROR_STATE_SUBTITLE =
  "Something went wrong fetching the latest openings. Please refresh the page or check back shortly.";
